// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"389":"679f807c","394":"e699a115","502":"dec4c112","750":"6b8274ec","2775":"91a13d17","8180":"83dbd7d2","8662":"95bed5f4"}[chunkId] + ".chunk.css";
};